export default "__VITE_ASSET__BsB$0m6V__"